import ManagePortionTable from './ManagePortionTable'

export default ManagePortionTable
